<template>
  <div style="padding: 20px">
    <div>
      <a-table
        :data-source="table.data"
        style="width: 100%">
        <a-table-column
          data-index="expressCompanyCode"
          title="时间">
          <template slot-scope="text,record">
            <time-formatter format="YYYY-MM-DD HH:mm" :time="record.createAt"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="status"
          title="操作后状态">
          <template slot-scope="text,record">
            {{ $dict('ORDER_STATUS',record.status)}}
          </template>
        </a-table-column>
<!--        <a-table-column-->
<!--          data-index="sender"-->
<!--          title="操作者">-->
<!--          <template slot-scope="text,record">-->
<!--            <span v-if="record.userId">{{record.user.name}}</span>-->
<!--            <span v-else-if="record.sysUserId">{{record.sysUser.userName}}</span>-->
<!--            <span v-else>系统触发</span>-->
<!--          </template>-->
<!--        </a-table-column>-->
      </a-table>
    </div>
  </div>
</template>

<script>
import {
  _queryOrderRecords,
} from '@/api/orderApi';
import TimeFormatter from '../../../components/TimeFormatter';

async function getOrderExpressList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryOrderRecords(this.orderId);
  this.table.data = result;
}

export default {
  name: 'OrderRecordList',
  components: { TimeFormatter },
  props: {
    orderId: String,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getOrderExpressList,
  },
  created() {
    this.getOrderExpressList();
  },
};
</script>

<style scoped>

</style>
